import { ORDER_CANCELLATION as $ST } from 'plugins/tfs/platformConfigs/staticTextMaps/order';
import $STP from 'plugins/tfs/platformConfigs/staticTextMaps/product';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import React, { Fragment, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {
  setCancelerOrderItems,
  fetchCancellationReasons,
  refundOrder,
} from 'actions/orderCancellation';
import { openImageModal } from 'actions/imageModal';
import PageTitle from 'theme/PageTitle';
import Button from 'theme/Button';
import Icon from 'theme/Icon';
import $S from 'theme/settings';
import Image from 'theme/Image';
import SubModal from 'theme/SubModal';
import ModalSpinner from 'theme/ModalSpinner';
import Selectbox from 'theme/Selectbox';
import Clear from 'theme/Clear';
import Error from 'theme/Error';
import { thumbnailImageUrl } from 'theme/utils';
import { useDispatch } from 'react-redux';

// pageContainer
import OrderAcceptComplete from '_pageContainers/orders/cancellation/orderRefundComplete';

const OrderAcceptCompleteGrid = (pageContext) => {
  const dispatch = useDispatch();
  const [cancellationOptions, setCancellationOptions] = useState([]);
  const [requestBody, setRequestBody] = useState({
    order: -1,
    forced_refund_amount: null,
    cancel_items: [],
    reasons: {},
  });
  const [reasonsItem, setReasonsItem] = useState(null);
  const [reRender, setReRender] = useState(false);

  const {
    props: { success, pending, error },
    redirect,
    orderNumber,
    successModal,
    currentStaff,
    cleanStateAndRedirect,
    closeModal,
    printPage,
  } = pageContext;

  useEffect(() => {
    dispatch(fetchCancellationReasons());
    dispatch(
      setCancelerOrderItems(
        localRefundOrderData,
        localRefundedOrderItems,
        localRefundInvoiceNumber
      )
    );
  }, []);

  const cancellationReasonData = useSelector(
    (state) => state.orderCancellation.cancellationReasons
  );

  const cancellationReasonPending = useSelector(
    (state) => state.orderCancellation.cancellationReasonsPending
  );

  const refundInvoiceNumber = useSelector(
    (state) => state.orderCancellation.refundInvoiceNumber
  );
  const orderRefundItems = useSelector((state) => state.orderRefund.orderItems);
  let orderItems =
    useSelector((state) => state.orderCancellation.orderItems) ||
    orderRefundItems;

  const order = useSelector((state) => state.orderCancellation.order);
  const orderPending = useSelector((state) => state.orderCancellation.pending);

  let localRetailStore = JSON.parse(
    localStorage.getItem('localCurrentRetailStore')
  );

  let localCurrentStaff = JSON.parse(localStorage.getItem('localCurrentStaff'));

  let localRefundOrderData = JSON.parse(
    localStorage.getItem('localCancelOrderData')
  );

  let localRefundedOrderItems = JSON.parse(
    localStorage.getItem('localCanceledOrderItems')
  );

  let localRefundInvoiceNumber = JSON.parse(
    localStorage.getItem('localCancelInvoiceNumber')
  );

  const staffInfo = localRetailStore.find(
    (store) => store.id === localCurrentStaff
  );
  const storeInfo = JSON.parse(localStorage.getItem('popularStore'));

  useEffect(() => {
    let crArray =
      cancellationReasonData.length &&
      cancellationReasonData.map((cr) => {
        return {
          label: cr.subject,
          value: cr.pk,
        };
      });
    setCancellationOptions([...crArray]);

    const reasonsData = requestBody.reasons;
    Object.keys(orderItems).forEach((oi) => {
      if (!reasonsData[oi]) {
        reasonsData[oi] = crArray.length && crArray[0].value;
      }
    });
    setReasonsItem(reasonsData);
    setRequestBody({
      ...requestBody,
      order: order.pk,
      cancel_items: Object.keys(orderItems).map((oi) => parseInt(oi, 10)),
      reasons: reasonsData,
    });
  }, [cancellationReasonPending]);

  const renderOrderItems = (orderItems) => {
    return order.orderitem_set
      .filter((oi) => {
        return orderItems[oi.pk];
      })
      .map((oi, index) => {
        const image =
          oi.product.productimage_set.length &&
          oi.product.productimage_set[0].image;
        return (
          <div className='row order-refund-complete-item' key={index}>
            <div className='col-3' style={{ border: '1px solid #ddd' }}>
              <Image
                src={thumbnailImageUrl(image, 90, 90)}
                classes={'product-item__imageWrapper'}
                width={90}
                height={90}
                onClick={() =>
                  dispatch(openImageModal(thumbnailImageUrl(image, 600, 600)))
                }
              />
            </div>
            <div
              className='col-9'
              style={{
                border: '1px solid #ddd',
                borderLeft: '0',
                padding: '20px',
              }}
            >
              <div
                className='row'
                style={{ fontSize: '13px', lineHeight: '24px' }}
              >
                <div className='col-5'>
                  <strong>{oi.product.sku}</strong>
                  <p>{oi.product.name}</p>
                  <p>
                    {oi.product.price} {oi.product.price_currency}
                  </p>
                  <p>
                    {oi.product.attributes.renk} {oi.product.attributes.beden}
                  </p>
                </div>
                <div className='col-7'>
                  <strong>{$ST.CANCEL_REASON}</strong>
                  {cancellationOptions.length > 0 && (
                    <Selectbox
                      classes='cancellation-reasons hide-on-print'
                      name='cancellation_reason'
                      icon='oksag'
                      options={cancellationOptions}
                      value={reasonsItem[oi.pk]}
                      onChange={(value) => setCancellationReason(oi.pk, value)}
                    />
                  )}
                  <p className='show-on-print'>
                    {cancellationOptions.length &&
                      cancellationOptions.filter(
                        (cr) => cr.value === requestBody.reasons[oi.pk]
                      )[0].label}
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
      });
  };

  const renderOrderItemsSimple = (orderItems) => {
    return order.orderitem_set
      .filter((oi) => {
        return orderItems[oi.pk];
      })
      .map((oi, index) => {
        return (
          <p key={index}>
            {oi.product.sku} - {oi.product.name} - {oi.product.attributes.renk}{' '}
            {oi.product.attributes.beden}
          </p>
        );
      });
  };

  const setCancellationReason = (orderItemPk, value) => {
    requestBody['reasons'][orderItemPk] = parseInt(value, 10);
    setRequestBody(requestBody);
    renderOrderItems(orderItems);
    setReRender(true);
  };

  const refundOrderData = () => {
    let actualCurrentStaff = currentStaff;
    if (Object.keys(currentStaff).length > 0) {
      requestBody['staff_remote_id'] = actualCurrentStaff.remote_id;
      requestBody['retail_store_remote_id'] =
        actualCurrentStaff.current_store.remote_id;
    }
    if ($S.hasOrderRefundInvoiceNumber)
      requestBody['refund_invoice_number'] = refundInvoiceNumber;
    dispatch(refundOrder(requestBody));
  };

  if (reRender) {
    setReRender(false);
    return renderOrderItems(orderItems);
  }

  if (redirect) {
    return (
      <Redirect
        to={{
          pathname: $R.ORDER_CANCELLATION_SEARCH.path,
          state: { number: orderNumber },
        }}
      />
    );
  }

  return (
    <div className='continer-fluid'>
      {(pending ||
        cancellationReasonPending ||
        cancellationReasonData.length === 0 ||
        !order.pk) && <ModalSpinner />}
      {successModal && success && !orderPending && (
        <SubModal
          classes='text-center inner-centered'
          onClose={closeModal}
          buttonText={$STP.OKAY}
        >
          <p
            style={{
              margin: '15px 0 30px 0',
              fontSize: '1.2rem',
            }}
          >
            {$ST.REFUND_ACCEPTED}
          </p>
          <br />
          <Button
            classes='button pointer float-left'
            onClick={() => printPage()}
            style={{
              width: '100%',
            }}
          >
            {$ST.PRINT}
          </Button>
          <Clear />
          <br />
          <br />
        </SubModal>
      )}
      <div className='row'>
        <div className='col-12 col-md-6 full-width-on-print'>
          <div
            className='login_form-container'
            style={{ padding: '80px 30px 0' }}
          >
            <div style={{ margin: '0 -17px' }}>
              <PageTitle classes='hide-on-print'>
                <Button
                  classes='pointer float-left'
                  onClick={() => cleanStateAndRedirect()}
                >
                  {$ST.ORDER_CANCELLATION_ACCEPTANCE}
                </Button>
                <span style={{ fontSize: '16px', margin: '0 5px' }}>
                  <Icon icon='oksag' />
                </span>
                {$ST.CONFIRM}
              </PageTitle>
              <br />
              <br />
              <br />
              <h4 className='form-title-hero'>
                {$ST.CANCEL_PRODUCTS_TO_BE_OPENED} ({order && order.number})
              </h4>
              <h4 className='form-title-hero'>
                {Object.keys(orderItems).length} {$ST.PIECES}
              </h4>
            </div>
            <div className='show-on-print' style={{ margin: '0 -17px' }}>
              <h4 className='form-title-hero'>
                {$ST.STAFF_WHO_DOES_REFUND_ACCEPT}
              </h4>
              {localRetailStore[0].current_store && (
                <Fragment>
                  <p style={{ marginBottom: '15px' }}>
                    <strong>
                      {localRetailStore[0].first_name}
                      {localRetailStore[0].last_name}
                    </strong>
                  </p>
                  <p>{localRetailStore[0].current_store.name}</p>
                  <p style={{ marginBottom: '30px' }}>
                    {localRetailStore[0].current_store.id}
                  </p>
                </Fragment>
              )}
            </div>
            {cancellationOptions.length > 0 &&
              order.pk &&
              renderOrderItems(orderItems)}
          </div>
        </div>
        <div
          className='col-12 col-md-6 store-select-wrapper hide-on-print'
          style={{ paddingTop: '90px' }}
        >
          <h4 className='form-title-hero'>{$ST.ORDER_CANCEL_ACCEPT_SUMMARY}</h4>
          <p>
            <strong>
              {Object.keys(orderItems).length} {$ST.PIECES}
            </strong>
          </p>
          <div style={{ lineHeight: '24px', margin: '20px 0 40px' }}>
            <p style={{ marginBottom: '12px' }}>
              <strong>{$ST.CANCEL_PRODUCTS}</strong>
            </p>
            {order.pk && renderOrderItemsSimple(orderItems)}
          </div>
          <h4 className='form-title-hero'>
            {$ST.STAFF_WHO_DOES_CANCEL_ACCEPT}
          </h4>
          <p style={{ marginBottom: '15px' }}>
            <strong>
              {staffInfo.first_name} {staffInfo.last_name}
            </strong>
          </p>
          <p style={{ marginBottom: '30px' }}>{storeInfo.name}</p>
          <Error data={error} field='order' />
          <Error data={error} field='cancelItems' />
          <Error data={error} field='reasons' />
          <Error data={error} field='forcedRefundAmount' />
          <Error data={error} field='non_field_errors' />
          <Button
            classes='button red pointer float-left'
            onClick={() => refundOrderData()}
            disabled={pending}
          >
            {$ST.CREATE_ORDER_CANCEL}
          </Button>
          <Clear />
        </div>
      </div>
    </div>
  );
};

export default OrderAcceptComplete(OrderAcceptCompleteGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/orders/cancellation/orderCancellationComplete/index.js